import React from "react";

/**
 * FormActionBar — fixed bottom action bar for full-page forms.
 *
 * Pins to the bottom of the content area, offset by the sidebar so it never
 * overlaps it.
 *
 * ⚠️ Pair it with the `has-form-actionbar` class on the page's scroll container,
 * or the last element sits underneath the bar. That class is NOT here — it is
 * rendered by 17 pages that import their own SCSS, so it lives in
 * `styles/shell/_content.scss` with the rest of the content-area geometry.
 *
 * Props:
 *   info      — optional node rendered left-aligned (e.g. an "unsaved" hint)
 *   children  — action buttons, right-aligned
 *   className — extra class on the bar
 */
const FormActionBar = ({ info = null, children, className = "" }) => (
  <div
    className={`tw-fixed tw-left-0 md:tw-left-[var(--shell-sidebar-w)] tw-right-0 tw-bottom-0 tw-z-20 tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 md:tw-px-6 md:tw-py-3 tw-bg-surface-raised tw-border-t tw-border-line tw-shadow-[0_-4px_16px_var(--card-shadow-hover)] ${className}`.trim()}
  >
    {info != null && (
      <div className="tw-flex tw-items-center tw-min-w-0 tw-text-content-subtle tw-text-[0.8125rem]">
        {info}
      </div>
    )}
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-ml-auto">
      {children}
    </div>
  </div>
);

export default FormActionBar;
